import { useStore } from 'effector-react'
import * as React from 'react'

import { $clientPartner, $partnerProfile, partnerProfileMounted } from './model'

export const usePartnerProfile = () => {
  const partnerProfile = useStore($partnerProfile)
  const clientPartner = useStore($clientPartner)

  React.useEffect(() => {
    partnerProfileMounted()
  }, [])

  return { partnerProfile, clientPartner }
}
